export const statusColorClass = (status: string) => {
    switch (status.toLocaleLowerCase()) {
        case 'live':
            return 'text-success';
        case 'unreleased':
            return 'text-warning';
        case 'inactive':
            return 'text-danger';
        case 'archived':
            return 'text-secondary';
        default:
            return 'text-info';
    }
};
